import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import {
  Form,
  TextInput,
  TextAreaInput,
  SubmitButton,
  UploadImage,
} from '@components/Form'
import { useLocalization } from '@contexts/LocalizationContext'
import validationSchema from './validationSchema'

const FormComponent = ({ handleSubmit, defaultValues = {} }) => {
  const { t } = useLocalization()

  const formItemLayout = {
    labelAlign: 'left',
  }
  return (
    <Form
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema(t)}
    >
      <Row>
        <Col flex="200px">
          <UploadImage
            formItemOptions={{ formItemLayout }}
            label={t('hospital.form.label.logo')}
            name="image"
            defaultValue={defaultValues.image}
          />
        </Col>
        <Col flex="auto">
          <TextInput
            name="name"
            label={t('hospital.form.label.name')}
            formItemOptions={{ formItemLayout }}
            defaultValue={defaultValues.name}
          />
          <TextAreaInput
            name="location"
            label={t('hospital.form.label.location')}
            formItemOptions={{ formItemLayout }}
            defaultValue={defaultValues.location}
          />
          <TextInput
            name="availableTime"
            label={t('hospital.form.label.availableTime')}
            formItemOptions={{ formItemLayout }}
            defaultValue={defaultValues.availableTime}
          />
          <TextInput
            name="telemedUrl"
            label={t('hospital.form.label.telemedUrl')}
            formItemOptions={{ formItemLayout }}
            defaultValue={defaultValues.telemedUrl}
          />
          {/* <SelectInput
            name="specialistIds"
            label={t('hospital.form.label.specialties')}
            options={specialties}
            formItemOptions={{ formItemLayout }}
            mode="multiple"
            allowClear
          /> */}
          <SubmitButton formItemOptions={{ formItemLayout }}>
            {t('hospital.form.saveButton')}
          </SubmitButton>
        </Col>
      </Row>
    </Form>
  )
}

FormComponent.propTypes = {
  handleSubmit: PropTypes.func,
  specialties: PropTypes.array,
  defaultValues: PropTypes.object,
}

export default FormComponent
